import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import {
	DetailsContainerStyled,
	DetailsHeaderStyled,
	DetailsItemStyled,
	DetailsTextStyled,
	SeparatorStyled,
} from './ApplicationDetailsM.styles';

interface ApplicationDetailsMProps {
	price: string;
	type: string;
	downloads: number | null;
	plans: boolean;
	languages: string[];
}

export const ApplicationDetailsM: FC<ApplicationDetailsMProps> = ({ price, type, downloads, plans, languages }) => {
	const { t } = useTranslation();

	return (
		<DetailsContainerStyled>
			{!plans && (
				<>
					<DetailsItemStyled>
						<DetailsHeaderStyled>{t(`Marketplace_Price`)}</DetailsHeaderStyled>
						<DetailsTextStyled>{price}</DetailsTextStyled>
					</DetailsItemStyled>
					<SeparatorStyled />
				</>
			)}

			<DetailsItemStyled>
				<DetailsHeaderStyled>{t(`Marketplace_Downloads`)}</DetailsHeaderStyled>
				<DetailsTextStyled>{downloads !== null ? downloads : `???`}</DetailsTextStyled>
			</DetailsItemStyled>
			<SeparatorStyled />
			<DetailsItemStyled>
				<DetailsHeaderStyled>{t(`Marketplace_Type`)}</DetailsHeaderStyled>
				<DetailsTextStyled>{type}</DetailsTextStyled>
			</DetailsItemStyled>

			{plans && (
				<>
					<SeparatorStyled />
					<DetailsItemStyled>
						<DetailsHeaderStyled>{t(`Marketplace_Languages`)}</DetailsHeaderStyled>
						<DetailsTextStyled>{languages.map(n => n.slice(0, 2)).join(`, `)}</DetailsTextStyled>
					</DetailsItemStyled>
				</>
			)}
		</DetailsContainerStyled>
	);
};
